import { inject, Injectable, LOCALE_ID } from '@angular/core';

export type SupportedLocale = 'en' | 'th';

const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'th'];

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly localeId = inject(LOCALE_ID);

  getCurrentLocale(): SupportedLocale {
    const locale = this.localeId as string;
    if (SUPPORTED_LOCALES.includes(locale as SupportedLocale)) {
      return locale as SupportedLocale;
    }
    return 'en';
  }

  switchLanguage(targetLocale: SupportedLocale): void {
    if (typeof window === 'undefined') return;

    const currentLocale = this.getCurrentLocale();
    if (currentLocale === targetLocale) return;

    const url = window.location.href;
    const origin = window.location.origin;
    const pathWithSearch = url.slice(origin.length);

    // Strip existing locale prefix (e.g. /th/... → /...)
    const localePrefix = `/${currentLocale}/`;
    const strippedPath = pathWithSearch.startsWith(localePrefix)
      ? pathWithSearch.slice(localePrefix.length - 1) // keep leading /
      : pathWithSearch;

    // English is served at root, other locales under /<locale>/
    const newPath =
      targetLocale === 'en'
        ? strippedPath || '/'
        : `/${targetLocale}${strippedPath}`;

    window.location.href = origin + newPath;
  }
}
